export const LICENSES = [
  "VMS",
  "TOP_SYSTEM",
  "RECOMMENDATION",
  "COPILOT_LITE",
  "COPILOT",
] as const;

export type License = (typeof LICENSES)[number];

export const LICENSE_TIER: Record<License, number> = {
  VMS: 0,
  TOP_SYSTEM: 1,
  RECOMMENDATION: 2,
  COPILOT_LITE: 3,
  COPILOT: 4,
};

export const isValidLicense = (value: unknown): value is License =>
  typeof value === "string" && value in LICENSE_TIER;

export const meetsLicenseTier = (
  current: License | undefined | null,
  required: License,
): boolean => {
  if (!isValidLicense(current)) return false;
  return LICENSE_TIER[current] >= LICENSE_TIER[required];
};
